export const KeyCode = {
  ENTER: 'Enter',
  ESCAPE: 'Escape',
};

export default KeyCode;
